module.exports = __webpack_public_path__ + "static/media/U1-T2-2-5d.c489f611.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-2-5d.svg
// module id = 564
// module chunks = 0